window.jQuery = window.$ = require('jquery');
var processInclude = require('base/util');
require('slick-carousel');

$(document).ready(function () {
    processInclude(require('./experience/dietPlanTabs'));
    processInclude(require('./slick/slick'));
    processInclude(require('./experience/youtube'));
    processInclude(require('./experience/scrollAnimate'));

    //update breadcrumb category link in page designer pages for diet plans
    $('.dietpage .breadcrumb-item').eq(1).find('a').attr('href', $('.diet-dropdown-menu').eq(0).find('a').attr('href'));
});
